export const I18_DEFAULT_NAME_SPACE = "common"
export const I18_DEFAULT_ENGLISH_SPACE = "english"
